import {
  afterNextRender,
  Component,
  inject,
  signal,
  Signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalizedUrlService } from '../../core/services/localized-url.service';
import { AppLocale, LocaleService } from '../../core/services/locale.service';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { fromStore } from 'angular/app/core/store';
import { ModalService } from '../../core/services/modal.service';
import { AuthService } from '../../core/services/auth.service';
import { ToastService } from '../../core/services/toast.service';
import { LogoutBaseComponent } from '../../shared/components/logout-base/logout-base.component';
import { PublicAppSection } from '../../core/store/ui/ui.state';

@Component({
  selector: 'app-public-navbar-links',
  template: `
    <app-dropdown-menu></app-dropdown-menu>

    <app-link-highlight
      [routerLink]="localizedUrl.link('search')"
      [routerLinkActiveOptions]="{ exact: false }"
      >{{ 'nav.public.search-room' | transloco }}</app-link-highlight
      >

      <div class="flex flex-col xl:flex-row items-start xl:items-center gap-4">
        @if ((B2C$ | async) === false) {
          <app-button
            [routerLink]="localizedUrl.link('partners')"
            variant="outlined"
            >{{ 'nav.public.become-reseller' | transloco }}
          </app-button>
        }
        @if (
          (isLoggedIn$ | async) === false &&
          (B2C$ | async) === false &&
          isPlatformBrowser()
          ) {
          <app-button
            id="login-button"
            [routerLink]="localizedUrl.authLink('login')"
            variant="secondary"
            >{{ 'nav.public.login' | transloco }}
          </app-button>
        }
        @if (
          (isLoggedIn$ | async) === false &&
          (B2C$ | async) === true &&
          vendorSlug()
          ) {
          <app-button
            id="login-button"
            [routerLink]="localizedUrl.authLink('login')"
            variant="outlined"
            >{{ 'nav.public.host-space' | transloco }}
          </app-button>
        }
      </div>

      <!-- Sélecteur de langue : à la suite des items en mobile, après le login en desktop -->
      <div class="self-start pl-4 xl:self-auto xl:ml-2 xl:pl-0">
        <app-locale-switcher (localeSelected)="setLocale($event)" />
      </div>

      @if ((isLoggedIn$ | async) === true) {
        <app-link-highlight
          [attr.data-cy]="'navbar-admin'"
          routerLink="/reservations"
          >
          {{ 'nav.public.admin' | transloco }}
        </app-link-highlight>
      }
      @if (isLoggedIn$ | async) {
        <app-link-highlight
          id="logout-button"
          (onClick)="logout()"
          >
          <i class="fal fa-sign-out"></i>
        </app-link-highlight>
      }
    `,
  styles: [],
  standalone: false,
})
export class PublicNavbarLinksComponent extends LogoutBaseComponent {
  isLoggedIn$: Observable<boolean> = this.store.select(fromStore.isLoggedIn);
  B2C$: Observable<boolean> = this.store
    .select(fromStore.selectPublicAppSection)
    .pipe(
      map((publicAppSection: PublicAppSection) => {
        return publicAppSection === PublicAppSection.B2C;
      }),
    );
  vendorSlug: Signal<string | null> = this.store.selectSignal(
    fromStore.selectVendorSlug,
  );
  protected localizedUrl = inject(LocalizedUrlService);
  localeService = inject(LocaleService);
  private router = inject(Router);
  isPlatformBrowser = signal(false);

  constructor(
    private store: Store,
    modalService: ModalService,
    authService: AuthService,
    toastService: ToastService,
  ) {
    super(modalService, authService, toastService);

    afterNextRender(() => {
      this.isPlatformBrowser.set(true);
    });
  }

  setLocale(locale: AppLocale): void {
    if (this.localizedUrl.localeFromUrl(this.router.url)) {
      this.router.navigateByUrl(this.localizedUrl.equivalentUrl(locale));
    } else {
      this.localeService.setLocale(locale);
    }
  }
}
